<!-- 商品信息 -->
<template>
    <div class="goods-info">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="left search flex flex-align-center" style="width:120px;">
                            <input type="text" class="left" placeholder="请输入商品名" v-model="goods">
                            <i class="el-icon-search" @click="searchGoods"></i>
                            <ul class="details_search" @click.stop="" :style="{display:(goodCheckArr[0]?'block':'none')}">
                                <div class="leftIcon" :style="{top:(curGoodIdx*40+'px')}">
                                    <div class="iconInner"></div>
                                </div>
                                <li v-for="item in goodCheckArr" @click="selSearchGood(item,'search')">
                                    <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                                </li>
                            </ul>
                        </div>
                        <div class="fliter type">
                            分类选择：
                            <el-select v-model="fliter_type" style="width:120px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option 
                                    v-for="item in systemData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                                <el-option 
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <!-- <el-cascader
                                v-model="fliter_type"
                                :options="typeOptions"
                                :show-all-levels="false"
                            ></el-cascader> -->
                        </div>
                        <span class="fliter">
                            管理库存：
                            <el-select v-model="fliter_stock">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option key="true" label="是" value="true"></el-option>
                                <el-option key="false" label="否" value="false"></el-option>
                            </el-select>
                        </span>
                        <span class="fliter">
                            厨房打印：
                            <el-select v-model="fliter_kitchen">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option key="true" label="是" value="true"></el-option>
                                <el-option key="false" label="否" value="false"></el-option>
                            </el-select>
                        </span>
                        <div class="left searchBtn" style="padding-left:10px;">
                            <button type="button" @click="fliterGoods" style="padding: 0 10px">筛选</button>
                        </div>
                        <div class="right searchBtn">
                            <button type="button" @click="addGoods"><i class="el-icon-plus"></i>添加商品</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:4%">序号</th>
                                <th style="width:8%">商品</th>
                                <th style="width:10%">商品名</th>
                                <th style="width:8%">分类</th>
                                <th style="width:5%">排序值</th>
                                <!-- <th style="width:8%">成本价</th> -->
                                <!-- <th style="width:6%">规格</th> -->
                                <th style="width:6%">销售价</th>
                                <!-- <th style="width:10%">供应商</th> -->
                                <th style="width:11%">销售时间段</th>
                                <th style="width:11%">折扣时间段</th>
                                <th style="width:6%">会员价</th>
                                <th style="width:4%">折扣价</th>
                                <th style="width:5%">厨房打印</th>
                                <th style="width:5%">标签打印</th>
                                <th style="width:5%">管理库存</th>
                                <!-- <th style="width:5%">状态</th> -->
                                <th style="width:12%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:vipData.length > 6}">
                                    <tr v-for="(item,idx) in vipData">
                                        <td style="width:4%" v-text="item.id?(idx+1):''"></td>
                                        <td style="width:8%" class="img">
                                            <div class="img_box" v-if='item.id'>
                                                <img :src="item.imageURL+'?x-oss-process=image/resize,l_300'" alt="">
                                            </div>
                                        </td>
                                        <td style="width:10%" v-text="item.name" :title="item.name"></td>
                                        <td style="width:8%" v-text="item.typeName"></td>
                                        <td style="width:5%" v-text="item.sort"></td>
                                        <!-- <td style="width:8%" v-text="item.costPrice"></td> -->
                                        <!-- <td style="width:6%" v-text="item.name?(item.stockQuantityRatio+'个/件'):''"></td> -->
                                        <td style="width:6%" v-text="item.salesPrice"></td>
                                        <!-- <td style="width:10%" v-text="item.supplierName"></td> -->
                                        <td style="width:11%" >
                                            <span v-if="item.id&&item.supplyTimes&&JSON.parse(item.supplyTimes).length">
                                                <span 
                                                    v-for="oitem in JSON.parse(item.supplyTimes)"
                                                    v-text="(oitem.beginHour<10?'0'+oitem.beginHour:oitem.beginHour)+':'
                                                    +(oitem.beginMinute<10?'0'+oitem.beginMinute:oitem.beginMinute)+'~'
                                                    +(oitem.endHour<10?'0'+oitem.endHour:oitem.endHour)+':'
                                                    +(oitem.endMinute<10?'0'+oitem.endMinute:oitem.endMinute)+','"
                                                ></span>
                                            </span>
                                            <span v-if="(item.id&&!item.supplyTimes)||item.supplyTimes=='[]'">全天</span>
                                        </td>
                                        <td style="width:11%">
                                            <span v-if="item.id&&item.disShow">
                                                <span>{{item.nowHours+'~'+item.tomorrowHour}}</span>
                                            </span>
                                            <span v-if="(item.id&&!item.disShow)">暂无</span>
                                        </td>
                                        <td style="width:6%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:!item.memberShow}"
                                                v-text="item.memberShow?'是':'否'">
                                            </span>
                                        </td>
                                        <td style="width:4%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:!item.disShow}"
                                                v-text="item.disShow?'是':'否'">
                                            </span>
                                        </td>
                                        <td style="width:5%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:!item.kitchenPrintEnabled}"
                                                v-text="item.kitchenPrintEnabled?'是':'否'">
                                            </span>
                                        </td>
                                        <td style="width:5%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:!item.labelEnabled}"
                                                v-text="item.labelEnabled?'是':'否'">
                                            </span>
                                        </td>
                                        <td style="width:5%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:!item.stockEnabled}"
                                                v-text="item.stockEnabled?'是':'否'">
                                            </span>
                                        </td>
                                        <!-- <td style="width:5%" >
                                            <span
                                                class="goods_status_on"
                                                v-if="item.id"
                                                :class="{goods_status_off:item.productStatus=='OFF'}"
                                                v-text="item.productStatus==='OFF'?'下架':'上架'">
                                            </span>
                                        </td> -->
                                        <td style="width:12%">
                                            <div v-if="item.id" class="btnInline">
                                                <el-button type="text"  title="修改" @click="uploadGood(item)"><i class="iconfont icon-bianji"></i></el-button>
                                                <el-button type="text"  title="删除" @click="delGoods(item.id)"><i class="iconfont icon-icon1460188478041"></i></el-button>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="btnId?'修改商品':'添加商品'"
            :visible.sync="dialogVisible"
            size="tiny"
            v-loading.body="infoload">
            <div>
                <div class="msgBox clearfix" @click="hideSearchList">
                    <div class="left msgItem clearfix searchbox">
                        <span class="left itemName"><i>*</i>商品名</span>
                        <input type="text" class="left itemInput" v-model="newGoods.name" placeholder="请输入商品名">
                         <ul class="details_search add_details_search" @click.stop="" :style="{display:(addGoodCheckArr[0]?'block':'none')}">
                            <div class="leftIcon" :style="{top:(addCurGoodIdx*40+'px')}">
                                <div class="iconInner"></div>
                            </div>
                            <li v-for="item in addGoodCheckArr" @click="selSearchGood(item,'add')">
                                <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="left msgItem clearfix searchbox">
                        <span class="left itemName">商品描述</span>
                        <input type="text" class="left itemInput" v-model="newGoods.note" placeholder="请输入商品描述">
                    </div>
                    <div class="left msgItem clearfix" >
                        <span class="left itemName"><i>*</i>商品分类</span>
                        <el-select placeholder="请选择商品分类" v-model="newGoods.productTypeId" class="itemSelect" style="width:40%;">
                            <el-option 
                                    v-for="item in systemData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"></el-option>
                            <el-option
                                v-for="item in typeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>数量/价格</span>
                        <input type="text" style="width:50px;text-align:center;" class="left itemInput" v-model="newGoods.productQty" placeholder="数量">
                        <span class="left">个</span>
                        <input type="text" style="width:50px;text-align:center;" class="left itemInput" v-model="newGoods.salesPrice" placeholder="价格">
                        <span class="left">元</span>
                    </div>
                    <!--  -->
                    <!-- <div class="left msgItem clearfix" >
                        <span class="left itemName">商品规格</span>
                        <el-select placeholder="请选择商品规格" multiple clearable collapse-tags v-model="newGoods.specIds" :class="(newGoods.specIds && Array.isArray(newGoods.specIds) && newGoods.specIds.length>1)?'showMore':''" class="itemSelect" style="width:40%;">
                            <el-option
                                v-for="item in specList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div> -->
                    <!--  -->
                    <!-- <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>销售状态</span>
                        <el-radio class="radio left itemRadio" v-model="newGoods.productStatus" label="ON">上架</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newGoods.productStatus" label="OFF">下架</el-radio>
                    </div> -->
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>商品排序</span>
                        <input type="text" class="left itemInput" v-model="newGoods.sort" style="width:30%" placeholder="" maxlength="6">
                    </div>
                    <!--  -->
                    <!-- <div class="left msgItem clearfix" style="position:relative">
                        <span class="left itemName" style="width:50%"><i>*</i>配品规格开关
                             <el-tooltip class="item" effect="dark" content="开启后，点单时自动弹出规格窗口" placement="top">
                                 <i class="iconfont icon-wenhao-yuankuang"></i>
                            </el-tooltip>
                        </span>
                        <el-radio class="radio left itemRadio" style="width:20%" v-model="newGoods.openMatchEnabled" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio" style="width:20%"  v-model="newGoods.openMatchEnabled" :label="false">否</el-radio>
                    </div> -->
                    <!--  -->
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>管理库存</span>
                        <el-radio class="radio left itemRadio" v-model="isStock" label="ON">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="isStock" label="OFF">否</el-radio>
                    </div>
                    <div class="left msgItem clearfix" v-if="isStock=='ON'">
                        <span class="left itemName"><i>*</i>库存告警值</span>
                        <input type="text" style="width:100px;text-align:center;" class="left itemInput" v-model="newGoods.threshold" placeholder="数量">
                        <!-- <span class="left">个</span> -->
                    </div>
                    <!-- <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>每件规格</span>
                        <input type="text" class="left itemInput" v-model="newGoods.stockQuantityRatio" style="width:30%" placeholder="请输入规格">
                        <span class="left" style="width:30%">个/件</span>
                    </div> -->
                    <!-- <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>标签打印</span>
                        <el-radio class="radio left itemRadio" v-model="isDirectThermal" label="ON">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="isDirectThermal" label="OFF">否</el-radio>
                    </div> -->


                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>厨房打印</span>
                        <el-radio class="radio left itemRadio" v-model="kitchenPrintEnabled" label="ON">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="kitchenPrintEnabled" label="OFF">否</el-radio>
                    </div>
                    <div class="left msgItem clearfix" v-if="kitchenPrintEnabled=='ON'">
                        <span class="left itemName"><i>*</i>打印机</span>
                        <el-select placeholder="请选择打印机" v-model="newGoods.ipId" class="itemSelect" style="width:40%;">
                            <el-option
                                :key="-1"
                                :label="'无'"
                                :value="''">
                            </el-option>
                            <el-option
                                v-for="item in printEr"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>标签打印</span>
                        <el-radio class="radio left itemRadio" v-model="newGoods.labelEnabled" :label="1">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newGoods.labelEnabled" :label="0">否</el-radio>
                    </div>
                    <!-- 岗位提成 -->
                    <div class="left msgItem clearfix" style="position:relative">
                        <span class="left itemName"><i>*</i>岗位提成
                             <el-tooltip class="item" effect="dark" content="开启岗位提成后，固定提成、时间段提成无效。" placement="top">
                                 <i class="iconfont icon-wenhao-yuankuang"></i>
                            </el-tooltip>
                        </span>
                        <el-radio class="radio left itemRadio" v-model="newGoods.postEnabled" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newGoods.postEnabled" :label="false">否</el-radio>
                        <span style="position:absolute;top:0px;right:30px;cursor:pointer;color:red;" v-if="newGoods.postEnabled==true" @click.stop="addCommJob">添加</span>
                    </div>
                    <!-- 岗位提成end -->
                    <!--  -->
                    <template v-if="newGoods.postEnabled==false">
                        <div class="left msgItem clearfix" style="position:relative">
                            <span class="left itemName"><i>*</i>时段提成
                                <el-tooltip class="item" effect="dark" content="开启时段提成后，岗位提成、固定提成无效。" placement="top">
                                    <i class="iconfont icon-wenhao-yuankuang"></i>
                                </el-tooltip>
                            </span>
                            <el-radio class="radio left itemRadio" v-model="newGoods.timeRangeComm" :label="true">是</el-radio>
                            <el-radio class="radio left itemRadio"  v-model="newGoods.timeRangeComm" :label="false">否</el-radio>
                            <span style="position:absolute;top:0px;right:30px;cursor:pointer;color:red;" v-if="newGoods.timeRangeComm==true" @click.stop="addCommTime">添加</span>
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix" v-if="newGoods.timeRangeComm==false">
                            <span class="left itemName"><i>*</i>商品提成</span>
                            <input type="text" class="left itemInput" v-model="newGoods.commission" style="width:30%" placeholder="请输入提成" maxlength="6">
                            <span class="left" style="width:30%">元</span>
                        </div>
                    </template>
                    <!-- 提成时间段设置 -->
                    <template v-if="newGoods.timeRangeComm==true && newGoods.postEnabled==false">
                        <div v-for="(timeItem ,timeIndex) in newTimeListForComm" :key="timeIndex">
                            <div class="left msgItem clearfix"  style="position:relative">
                                <span class="left itemName"><i>*</i>商品提成</span>
                                <input type="text" class="left itemInput" v-model="timeItem.commission" style="width:30%" placeholder="请输入提成" maxlength="6">
                                <span class="left" style="width:30%">元</span>
                            </div>
                            <div class="left msgItem clearfix saleTimes" style="display:flex">
                                <span class="left itemName">提成时间段</span>
                                <div class="left timesBox clearfix" >
                                    <span class="itemSelect left">
                                        <el-time-picker
                                            is-range
                                            format="HH:mm"
                                            v-model="timeItem.timeRange"
                                            range-separator="至"
                                            start-placeholder="开始时间"
                                            end-placeholder="结束时间"
                                            placeholder="选择时间范围">
                                        </el-time-picker>
                                    </span>
                                </div>
                                <el-button type="text" @click.stop="delTimeList(timeItem,timeIndex)">删除</el-button>
                            </div>
                        </div>
                    </template>
                    <!-- end2020.5.30 -->
                    <!-- 岗位提成 -->
                    <template v-if="newGoods.postEnabled==true">
                        <div v-for="(jobComItem ,jobComIndex) in newJobListForComm" :key="jobComIndex">
                            <div class="left msgItem clearfix saleTimes" style="display:flex">
                                <span class="left itemName">岗位：</span>
                                <div class="left timesBox clearfix" >
                                        <el-select placeholder="请选择岗位" v-model="jobComItem.groupId" class="itemSelect" style="width:90%;">
                                            <el-option
                                                v-for="item in jobTypeList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                </div>
                            </div>
                            <div class="left msgItem clearfix"  style="position:relative">
                                <span class="left itemName"><i>*</i>商品提成</span>
                                <input type="text" class="left itemInput" v-model="jobComItem.commission" style="width:30%" placeholder="请输入提成" maxlength="6">
                                <span class="left" style="width:30%">元<el-button style="padding-left:5px" type="text" @click.stop="delJobComList(jobComItem,jobComIndex)">删除</el-button></span>
                            </div>
                        </div>
                    </template>
                    <!-- 岗位提成end -->
                    <div class="left msgItem clearfix">
                        <span class="left itemName">会员价</span>
                        <el-radio class="radio left itemRadio" v-model="vipEnable" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="vipEnable" :label="false">否</el-radio>
                    </div>
                    <div class="left msgItem clearfix" v-if="vipEnable">
                        <span class="left itemName"><i>*</i>会员价格</span>
                        <input type="text" class="left itemInput" v-model="vipPrice" style="width:30%" placeholder="请输入会员价格" maxlength="6">
                        <span class="left" style="width:30%">元</span>
                    </div>
                    <!--  -->
                    <!-- 呼叫 -->
                    <div class="left msgItem clearfix">
                        <span class="left itemName">展示在呼叫端</span>
                        <el-radio class="radio left itemRadio" v-model="newGoods.salesEnabled" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newGoods.salesEnabled" :label="false">否</el-radio>
                    </div>
                    <div class="left msgItem clearfix" v-if="newGoods.salesEnabled">
                        <span class="left itemName"><i>*</i>展示销售数量</span>
                        <el-radio class="radio left itemRadio" v-model="newGoods.salesShowEnabled" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newGoods.salesShowEnabled" :label="false">否</el-radio>
                    </div>
                    <div class="left msgItem clearfix" v-if="newGoods.salesEnabled&&newGoods.salesShowEnabled">
                        <span class="left itemName"><i>*</i>基础销售数量</span>
                        <input type="text" class="left itemInput" v-model="newGoods.salesCount" style="width:30%" placeholder="" maxlength="6">
                    </div>
                    
                    <!-- 呼叫end -->
                    <div class="left msgItem clearfix">
                        <span class="left itemName">显示在客户端</span>
                        <el-radio class="radio left itemRadio" v-model="pcEnable" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="pcEnable" :label="false">否</el-radio>
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName">客户端允许购买</span>
                        <el-radio class="radio left itemRadio" v-model="pcBuyEnable" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="pcBuyEnable" :label="false">否</el-radio>
                    </div>
                    
                    <!--  -->
                    
                    <div class="left msgItem clearfix">
                        <span class="left itemName">开启折扣</span>
                        <el-radio class="radio left itemRadio" v-model="discountEnable" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="discountEnable" :label="false">否</el-radio>
                    </div>
                    
                    <!-- <div class="left msgItem clearfix" v-if="discountEnable">
                        <span class="left itemName" style="width:40%;">折扣是否跨天</span>
                        <el-radio class="radio left itemRadio" v-model="croseDay" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="croseDay" :label="false">否</el-radio>
                    </div> -->
                    <div class="left msgItem clearfix" v-if="discountEnable">
                        <span class="left itemName"><i>*</i>折扣百分比</span>
                        <input type="text" class="left itemInput" v-model="discountPrice" style="width:10%" placeholder="折扣" maxlength="6">
                        <span class="left" style="width:30%">%</span>
                    </div>
                    <div class="left msgItem clearfix" v-if="discountEnable">
                        <span class="left itemName" style="width:35%;">折扣后商品提成</span>
                        <input type="text" class="left itemInput" v-model="disCom" style="width:20%" placeholder="提成" maxlength="6">
                        <span class="left" style="width:20%">元</span>
                    </div>
                    <div class="left msgItem clearfix" style="width:100%;min-height:32px;" v-if="discountEnable">
                        <span class="left itemName" style="width:20%"><i>*</i>折扣星期选择</span>
                        <div>
                            <el-checkbox v-model="isAllWeek" @change="handleChangeWeeksAll">全选</el-checkbox>
                        </div>
                    </div>
                    <div class="left msgItem clearfix" style="width:100%;min-height:32px;" v-if="discountEnable">
                        <div style="margin-left:10%;">
                            <el-checkbox-group v-model="newGoods.week" @change="handleChangeWeeks">
                                <el-checkbox v-for="weekItem in weeks" :label="weekItem" :key="weekItem">{{weekItem}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="left msgItem clearfix" style="width:100%;" v-if="discountEnable">
                        <span style="display:inline-block;font-size:1rem;text-align:right;width:16.79%;"><i style="color:#d65252;">*</i>折扣时间</span>
                         <el-time-picker
                            v-model="beginTime"
                            placeholder="起始时间">
                        </el-time-picker>
                        <el-time-picker
                            arrow-control
                            v-model="endTime"
                            placeholder="截止时间">
                        </el-time-picker>
                    </div>
                    <div class="left msgItem clearfix saleTimes">
                        <span class="left itemName">销售时间</span>
                        <div class="left timesBox clearfix" >
                            <div   class="left addTimeBox" @click="addTimes" :class="{addTimeBoxChoiced:timeChoiceBtn}">
                                <i class="el-icon-plus"></i>添加
                            </div>
                            <span v-if="!timeChoiceBtn&&!newTimeList.length" class="allDay">默认全天</span>
                            <span class="itemSelect left" v-if="timeChoiceBtn">
                                <el-select placeholder="选择时间段" v-model="timeChoice" >
                                    <el-option
                                        v-for="item in timeList"
                                        :key="item.id"
                                        :label="(item.beginHour<10?'0'+item.beginHour:item.beginHour)+':'
                                                        +(item.beginMinute<10?'0'+item.beginMinute:item.beginMinute)+'~'
                                                        +(item.endHour<10?'0'+item.endHour:item.endHour)+':'
                                                        +(item.endMinute<10?'0'+item.endMinute:item.endMinute)"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                                <span @click="timeChoiceBtn=false;" style="position:absolute;top:-12px;right:-6px;cursor:pointer;color:red;">&times;</span>
                            </span>
                            <div class="timesInner" id="timeSales">
                                <div v-for="oitem in newTimeList" class="timesInnerItem clearfix">
                                    <p 
                                        class="left timeText"
                                        v-text="(oitem.beginHour<10?'0'+oitem.beginHour:oitem.beginHour)+':'
                                                    +(oitem.beginMinute<10?'0'+oitem.beginMinute:oitem.beginMinute)+'~'
                                                    +(oitem.endHour<10?'0'+oitem.endHour:oitem.endHour)+':'
                                                    +(oitem.endMinute<10?'0'+oitem.endMinute:oitem.endMinute)+'('+oitem.name+')'"
                                    ></p>
                                    <p class="removeBtn right"  @click="removeTimes(oitem)">&times;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!--  -->
                    

                    

                    <div class="left img_box clearfix">
                        <span class="left itemName"><i>*</i>商品图片</span>
                        <div class="left img">
                            <div class="img_item left">
                                <img v-if="newGoods.imageURL" ref="goodsImg" :src="newGoods.imageURL+'?x-oss-process=image/resize,l_300'" alt="">
                                <span v-if="newGoods.imageURL" @click="delImg" class="del-img">X</span>
                            </div>
                            <div class="img_up_btn left">
                                <i class="iconfont icon-xiazai"></i>
                                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg" class="pcImgFile" title="选择图片">
                                <input type="file" accept="image/*" @change="coverImg" class="mobileImgFile">
                            </div>
                            <div class="clear"></div>
                            <div class="uploadImgTip">
                                支持JPG、JPEG、PNG格式，单张大小不超过5M，建议尺寸 600*600 px
                            </div>
                        </div>
                    </div>
                    <!--规格  -->
                    <!-- <div class="left mat-goods" style="padding:5px 0">
                        <span class="tit">规格:</span>
                        <span class="seled-mat-list">
                            <span v-for="(tag,index) in normalSpecs" :key="index"
                            @click.stop="modifyNorSpecs(tag)"
                            >
                                <el-tag
                                :class="seledNorSpec.indexOf(tag)!=-1?'':'nor'"
                                >
                                {{tag}}
                                </el-tag>
                            </span>
                            
                            <div style="padding-top:10px">
                                <el-tag
                                closable
                                v-for="(tag,index) in specs"
                                @close="modifySpec('del',index)"
                                :key="`_${index}`"
                                >
                                {{tag}}
                                </el-tag>
                            </div>
                        </span>
                        <div class="autospec">
                            <span class="tit">自定义规格:</span>
                            <span class="auto-spec">
                                <el-input @keyup.native.enter="modifySpec('add')" type="text" size="small" style="width:30%" v-model="autoSpec" placeholder="请输入自定义规格"/>
                            </span>
                            <el-button type="text">自定义输入，输入完成之后按回车键</el-button>
                        </div>
                    </div> -->
                    <div class="left mat-goods">
                        <span class="tit">商品规格:</span>
                        <span class="seled-mat-list">
                            <el-tag
                            closable
                            @close="closeSpec(tag)"
                            v-for="tag in seledSpec"
                            :key="tag.name"
                            >
                            {{tag.name}}
                            </el-tag>
                        </span>
                        <el-button type="text" @click="addSpec">+添加</el-button>
                        <!-- <span class="left itemName">商品规格</span>
                        <el-select placeholder="请选择商品规格" multiple clearable collapse-tags v-model="newGoods.specIds" :class="(newGoods.specIds && Array.isArray(newGoods.specIds) && newGoods.specIds.length>1)?'showMore':''" class="itemSelect" style="width:40%;">
                            <el-option
                                v-for="item in specList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select> -->
                    </div>
                    <!-- 规格end -->
                    <div class="left mat-goods">
                        <span class="tit">包含原料:</span>
                        <span class="seled-mat-list">
                            <el-tag
                            v-for="tag in seledMats"
                            :key="tag.name"
                            >
                            {{tag.name}}*{{tag.count}}
                            </el-tag>
                        </span>
                        <el-button type="text" @click="addMatGoods">+添加</el-button>
                    </div>
                    <div class="left mat-goods">
                        <span class="tit">配品:</span>
                        <span class="seled-mat-list">
                            <el-tag
                            closable
                            @close="closePei(tag)"
                            v-for="tag in seledPeiGoods"
                            :key="tag.name"
                            >
                            {{tag.name}}
                            </el-tag>
                        </span>
                        <el-button type="text" @click="addPeiGoods">+添加</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="dialogVisible=false" class="cancel">取消</button>
                <button type="button" @click="beforeUpGoods" class="save">保存</button>
            </span>
        </el-dialog>
        <!--  -->
        <el-dialog
        title="同步商品"
        :show-close="false"
        :before-close="cancelTb"
        :visible.sync="shareGoods"
        size="tiny"
        >
            <el-form :label-position="'top'" style="width:100%;display: flex;justify-content: center;" label-width="80px">
                <el-form-item >
                    <div style="text-align:center;">请选择需要将此商品同步到的店铺</div>
                    <el-select style="width:450px" v-model="tbForm.storeIds" multiple placeholder="请选择">
                        <el-option
                        v-for="item in storeList"
                        v-if="item.id!=curStoreId"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="cancelTb" class="cancel">取消</button>
                <button type="button" @click="doUpGoods" class="save">保存</button>
            </span>
        </el-dialog>
        <!--  -->
        <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
        <!-- <el-dialog
            title="原料"
            :visible.sync="showMat"
            size="tiny"
        > -->
            <!-- <div class="mat-goods"> -->
                <selGoods 
                    v-if="showMat"
                    @selOk="selOk"
                    :seledGoods="seledMats"
                    :storeId="curStoreId"
                    @closeSelGoods="showMat=false"
                />
                <selPeiGoods
                    v-if="showPei"
                    @selOk="selOkForPei"
                    :seledGoods="seledPeiGoods"
                    :storeId="curStoreId"
                    @closeSelGoods="showPei=false"
                />
                <selSpec
                    v-if="showSpec"
                    @selOk="selOkForSpec"
                    :seledGoods="seledSpec"
                    :storeId="curStoreId"
                    @closeSelGoods="showSpec=false"
                />
                <!-- <el-table
                ref="multipleTable"
                :data="matData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                    <el-table-column
                    type="selection"
                    width="55">
                    </el-table-column>
                    <el-table-column
                    label="原料名"
                    >
                        <template slot-scope="scope">{{ scope.row.name }}</template>
                    </el-table-column>
                    <el-table-column
                    label="原料单位"
                    >
                        <template slot-scope="scope">{{ unitFormat[scope.row.unitId] }}</template>
                    </el-table-column>
                </el-table> -->
            <!-- </div> -->
            <!-- <span slot="footer" class="dialog-footer">
                <button type="button" @click="showMat=false" class="cancel">取消</button>
                <button type="button" @click="saveSeledMats" class="save">保存</button>
            </span>
        </el-dialog> -->
    </div>
</template>

<script type="text/javascript">
    import imgCrop from '@/components/imgCrop/imgCrop.vue';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    import selGoods from "@/components/selGoods/selGoods";
    import selPeiGoods from "@/components/selPeiGoods/selGoods";
    import selSpec from "@/components/selSpec/selGoods";
    export default{
        components: {imgCrop,selGoods,selPeiGoods,selSpec},
        props: ['curStoreId'],
    	data () {
    		return {
                tbForm:{
                    storeIds:[]
                },
                shareGoods:false,
                storeList:[],
                // 
                seledSpec:[],
                showSpec:false,
                specList:[],
                uploadSpecs:[],
                seledNorSpec:[],
                autoSpec:"",
                seledPeiGoods:[],
                showPei:false,
                showMat:false,
                specs:[],
                normalSpecs:["冷","热","常温","微辣","中辣","不辣","加糖","不加糖","加冰","不加冰"],
                seledMats: [
                ],
                isAllWeek:false,
                weeks: [
                    "星期一",
                    "星期二",
                    "星期三",
                    "星期四",
                    "星期五",
                    "星期六",
                    "星期天",
                ],
                timeChoiceBtnForComm:false,
                printEr:[],
                pcEnable:true,
                pcBuyEnable:true,
                disCom:0,//开启折扣价后的提成金额
                beginTime:"",
                endTime:"",
                // croseDay:false,
                discountEnable:false,
                discountPrice:100,//折扣价格
                vipEnable:false,
                vipPrice:"",//会员价格
                systemData:[],
                timeList:[],
                timeChoice:'',
                timeChoiceForComm:["",""],
                timeChoiceBtn:false,
                newTimeList:[],
                newTimeListForComm:[{
                    commission:"",
                    timeRange:[]
                }],//提成时间段
                checkeds:false,
                isStock:'ON',//是否库存管理
                kitchenPrintEnabled:'OFF',//是否厨房打印
                isDirectThermal: 'OFF', // 是否贴纸打印
                dialogVisible: false,
                newGoods: {
                    timeRangeComm:false,
                    sort:0,
                    salesCount:0,
                    salesShowEnabled:false,
                    salesEnabled:false,
                // 
                    labelEnabled:0,//标签打印
                    id: '', // 员工id
                    productTypeId: '', // 员工id
                    name: '', // 员工姓名
                    barCode: '', // 条码
                    // costPrice: '', // 进价
                    salesPrice: '', // 出售价
                    storeId: this.curStoreId, // 商铺id
                    inStockNumber: '' ,// 库存
                    supplierName: '', // 供应商
                    supplyTimeEnd: '', // 起售时间
                    supplyTimeBegin: '', // 止售时间
                    productStatus: 'ON', // 状态
                    imageURL: '', // 图片路径
                    // stockQuantityRatio: '', // 每件多少个
                    commission:'0',//提成价格，默认为0
                    productQty:1,//商品数量默认为1
                    ipId:"",
                    threshold:0,//库存告警值
                    note:"",
                    week:[],
                    // openMatchEnabled:false,
                    specIds:[],
                },
                vipData:[],//所有商品列表
                goodsNum:{
                    pageNum:1,
                    pageSize:6,
                    total:0
                },
                btnId:'',//添加或修改商品按钮
                addId:'',
                coverImgMaxSize: 20*1024*1024, // 图片最大字节数
                oldImgBase64: '', // 原图base64
                showCrop: false, // 控制图片裁剪显示隐藏
                curCropW: 600, // 裁剪宽度
                curCropH: 600, // 裁剪高度
                infoload: false, // loading

                addGoodApiBtn: true, // 控制添加商品接口

                goodCheckArr:[],
                addGoodCheckArr:[],//添加商品搜索出来的商品列表
                isAutoSearchBtn:true,//添加商品是否开启检索
                addCurGoodIdx: 0, // 当前商品索引
                goods:'',
                curGoodIdx: 0, // 当前商品索引
                goodSearchBtn:true,

                fliter_type: '', // 当前筛选条件
                fliter_status: '', // 当前筛选条件
                fliter_stock: '', // 当前筛选条件
                fliter_kitchen: '', // 当前筛选条件
                typeList:[],
                multipleSelection:[],
                matData:[],
                unitOptions:[],
                unitFormat:{},
                // 
                jobTypeList:[],
                newJobListForComm:[
                    {
                        commission:"",
                        groupId:"",
                        id:""
                    }
                ],
    		}
    	},
        watch:{
            // "newGoods.timeRangeComm":function(val){
            //     if(val){
            //        $("#comm").parents(".msgItem").css("margin-bottom",this.newTimeListForComm.length * 25);
            //     }else{
            //         this.newTimeListForComm = [];
            //     }
            // },
            // newTimeListForComm:function(val){
            //     // if(this.newTimeListForComm.length){
            //        $("#comm").parents(".msgItem").css("margin-bottom",val.length * 25);
            //     // }
            // },
            newTimeList:function(val){
                // if(this.newTimeListForComm.length){
                    console.log($("#timeSales").parents(".msgItem").css("margin-bottom",val.length * 25));
                // }
            },
            goods : function(val){
                if(val){
                    this.searchGoods(val,null)
                }else {
                    this.goodCheckArr = [];
                    this.getGoodsData();
                }
            }, 
            'newGoods.name' : function(val){
                if(val){
                    // if(this.isAutoSearchBtn){
                        this.searchGoods(val,'9f5afd60-e952-11e7-a26a-83436326b6c5');
                    // }else {
                        
                    // }
                }else {
                    this.addGoodCheckArr = [];
                    // this.getGoodsData();
                }
            },
            timeChoice(val){
                if(val==''){
                    return;
                }
                if(this.newTimeList.length>=3){
                    this.$message({
                        message: '最多只能添加3个时间段',
                        customClass: 'error'
                    })
                    this.timeChoice = '';
                    return;
                }
                for (var i = 0; i < this.timeList.length; i++) {
                    if(val == this.timeList[i].id){
                        
                        let isPush = true;
                        for(var j=0;j<this.newTimeList.length;j++){
                            if(this.newTimeList[j].id == val){
                                isPush = false;
                                this.$message({
                                    message: '已经有该时段',
                                    customClass: 'error'
                                })
                            }
                        }
                        if(isPush){
                            this.newTimeList.push(this.timeList[i]); 
                        }
                    }
                }
                this.timeChoiceBtn = false;
                this.timeChoice = '';
            } ,
            // timeChoiceForComm(val){
            //     console.log(val)
            //     return;
            //     if(val==''){
            //         return;
            //     }
            //     if(this.newTimeListForComm.length>=5){
            //         this.$message({
            //             message: '最多只能添加5个时间段',
            //             customClass: 'error'
            //         })
            //         this.timeChoiceForComm = '';
            //         return;
            //     }
            //     this.newTimeListForComm.push(val); 
            //     this.timeChoiceForComm = '';
            // }
            dialogVisible(val){
                if(!val){
                    this.seledMats = [];
                    this.seledPeiGoods = [];
                    this.seledSpec = [];
                }
            }
        },
        methods: {
            modifyNorSpecs(tag){
                console.log(tag)
                let seledNorSpec = JSON.parse(JSON.stringify(this.seledNorSpec))
                if(seledNorSpec.indexOf(tag)!=-1){
                    seledNorSpec.splice(seledNorSpec.indexOf(tag),1);
                }else{
                    seledNorSpec.push(tag);
                }
                this.seledNorSpec = seledNorSpec;
            },
            modifySpec(type,index){
                let specs = JSON.parse(JSON.stringify(this.specs));
                if(type == "add"){
                    if(!String(this.autoSpec).trim()){
                        this.$message({
                            message: '请输入规格名称',
                            customClass: 'error'
                        })
                        return;
                    }
                    specs.push(this.autoSpec);
                    this.autoSpec = '';
                }else if(type=="del"){
                    specs.splice(index,1);
                }
                this.specs = specs;
            },
            // 
            getJobType(){
                this.$http.get('/employee-groups?storeId='+this.curStoreId).then((res)=>{
                    this.jobTypeList = res.data;
                }).catch((err)=>{

                })
            },
            delJobComList(item,index){
                let newJobListForComm = JSON.parse(JSON.stringify(this.newJobListForComm));
                newJobListForComm.splice(index,1);
                this.newJobListForComm = newJobListForComm;
            },
            // 
            delTimeList(item,index){
                let newTimeListForComm = JSON.parse(JSON.stringify(this.newTimeListForComm));
                newTimeListForComm.splice(index,1);
                this.newTimeListForComm = newTimeListForComm;
            },
            // 
            closeSpec(tag){
                console.log(tag);
                let seledSpec = JSON.parse(JSON.stringify(this.seledSpec));
                let index;
                let flag = false;
                if(seledSpec && Array.isArray(seledSpec) && seledSpec.length){
                    seledSpec.forEach((it,ind)=>{
                        if(it.id == tag.id){
                            index = ind;
                            flag = true;
                        }
                    })
                }
                seledSpec.splice(index,1);
                this.seledSpec = seledSpec;
            },
            // 
            closePei(tag){
                console.log(tag);
                let seledPeiGoods = JSON.parse(JSON.stringify(this.seledPeiGoods));
                let index;
                let flag = false;
                if(seledPeiGoods && Array.isArray(seledPeiGoods) && seledPeiGoods.length){
                    seledPeiGoods.forEach((it,ind)=>{
                        if(it.id == tag.id){
                            index = ind;
                            flag = true;
                        }
                    })
                }
                seledPeiGoods.splice(index,1);
                this.seledPeiGoods = seledPeiGoods;
                console.log(this.btnId)
                if(flag && this.btnId){
                    this.delPeiGoods(tag);
                }
            },
            delPeiGoods(tag){
                this.$http({
                    url:"match/product/delete",
                    method:"POST",
                    data:{
                        productId:this.btnId,
                        matchProductId:tag.id
                    }
                }).then(res=>{
                    this.$message({
                        message: '操作成功',
                        customClass: 'success'
                    })
                })
            },
            addPeiGoods(){
                this.showPei = true;
            },
            saveSeledMats(){
                let seledMats = JSON.parse(JSON.stringify(this.seledMats));
                let willbeSel = this.multipleSelection;
                seledMats = willbeSel;
                this.seledMats = seledMats;
                console.log(seledMats)
                this.showMat = false;
            },
            getUnitList(){
                this.$http({
                    url:"material/unit/list",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page:0,
                        size:10000
                    }
                }).then(res=>{
                    this.unitOptions = res.data;
                    let unitFormat = {};
                    if(res.data && Array.isArray(res.data) && res.data.length){
                        res.data.forEach(it=>{
                            unitFormat[it.id] = it.name
                        })
                    }
                    console.log(unitFormat)
                    this.unitFormat = unitFormat;
                    this.getDataList();
                })
            },
            getDataList(){
                this.$http({
                    url:"material/search/list",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page:0,
                        size:10000
                    }
                }).then(res=>{
                    this.matData = res.data;
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            addSpec(){
                this.showSpec = true;
                // this.getUnitList();
            },
            addMatGoods(){
                this.showMat = true;
                // this.getUnitList();
            },
            handleChangeWeeks(value) {
                console.log(value)
                // this.newGoods.week = value;
            },
            handleChangeWeeksAll(val){
                if(this.isAllWeek){
                    this.newGoods.week = this.weeks;
                }else{
                    this.newGoods.week = [];
                }
            },
            addCommJob(){
                let obj = {
                    commission:"",
                    groupId:"",
                    id:""
                }
                this.newJobListForComm.push(obj);
            },
            addCommTime(){
                let obj = {
                    commission:"",
                    timeRange:[]
                }
                this.newTimeListForComm.push(obj);
            },
            setTimeForComm(){
                console.log(new Date(this.timeChoiceForComm[0]).Format("hh:mm"))
                if(this.newTimeListForComm.length>=5){
                    this.$message({
                        message: '最多只能添加5个时间段',
                        customClass: 'error'
                    })
                    this.timeChoiceForComm = '';
                    return;
                }
                let obj = {
                    commPrice:"",
                    start:"",
                    end:""
                }
                this.newTimeListForComm.push(obj); 
                this.timeChoiceForComm = '';
            },
            // 获取打印数据
            getPrintIpInfo(){
                this.$http({
                url:"ip-list",
                method:"GET",
                params:{
                    storeId:this.curStoreId
                    }
                }).then(res=>{
                    this.printEr = res.data;
                    console.log(res);
                });
            },
            // 隐藏添加商品、修改商品时的商品名字检索
            hideSearchList(){
                this.addGoodCheckArr = [];
            },
            // 删除修改商品时的图片
            delImg(){
                this.$refs.goodsImg.src = 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
                this.newGoods.imageURL = 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
            },
            selSearchGood(item,boo){
                this.$http.get(item.id+'/product').then((res)=>{
                    if(boo=='add'){
                        console.log(res.data)
                        this.addGoodCheckArr = [];
                        this.addId = item.id;
                        this.newGoods = {
                            // barCode       : res.data.barCode,
                            // salesPrice    : res.data.salesPrice,
                            // inStockNumber : res.data.inStockNumber,
                            // supplierName  : res.data.supplierName,
                            name          : res.data.name,
                            imageURL      : res.data.imageURL,
                            productQty:1,
                            sort:0,
                            productStatus : 'OFF',
                            labelEnabled:0,
                            timeRangeComm:false,
                            salesEnabled:false,
                            // stockQuantityRatio : res.data.stockQuantityRatio,
                            commission : 0,
                            week : res.data.week ? (Array.isArray(res.data.week) ? res.data.week : res.data.week.split(",")) : [],
                            // productQty:res.data.productQty
                        };
                        this.timeChoiceBtn = false;
                        this.isStock ='OFF';
                        this.vipEnable = false;
                        this.kitchenPrintEnabled = 'OFF';
                        this.isDirectThermal = 'OFF';
                        this.dialogVisible = true ;
                        this.pcEnable = true;
                        this.pcBuyEnable = true;
                       this.addCurGoodIdx = 0;
                       this.discountEnable = false;
                    }else if(boo=='search') {
                        this.goodCheckArr = []; 
                        this.vipData = [res.data];
                        if( this.vipData.length < 6 ){
                            for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                                this.vipData.push({})
                            }
                        }
                    }
                })
            },
            // 商品检索
            searchGoods(val,id){
                if ( !this.goodSearchBtn ) {
                    return;
                }
                this.goodSearchBtn = false;
                this.$http.get('products/stores-search?storeId='+(id?id:this.curStoreId)+'&stockEnabled=false'+'&q='+encodeURI(val)).then((res)=>{
                    if(id){
                        this.addGoodCheckArr = res.data;
                        this.isAutoSearchBtn = false;
                        setTimeout(()=>{
                            this.isAutoSearchBtn = true;
                        },2000)
                        setTimeout(()=>{
                            let that = this;
                            $('.add_details_search li').hover( function () {
                                that.addCurGoodIdx = $(this).index()-1;
                            }, function () {
                                that.addCurGoodIdx = 0;
                            })
                        },0)
                    }else {
                        this.goodCheckArr = res.data;
                        setTimeout(()=>{
                            let that = this;
                            $('.details_search li').hover( function () {
                                that.curGoodIdx = $(this).index()-1;
                            }, function () {
                                that.curGoodIdx = 0;
                            })
                        },0)
                    }
                    this.goodSearchBtn = true;
                }).catch(()=>{
                    this.goodSearchBtn = true;
                })
            },
            //删除时段
            removeTimes(item){
                for (var i = 0; i < this.newTimeList.length; i++) {
                    if(this.newTimeList[i].id==item.id){
                        this.newTimeList.splice(i,1);
                    }
                }
            },
             //删除时段
            removeTimesForComm(item){
                for (var i = 0; i < this.newTimeListForComm.length; i++) {
                    if(this.newTimeListForComm[i].id==item.id){
                        this.newTimeListForComm.splice(i,1);
                    }
                }
            },
            addTimesForComm(){
                this.timeChoiceBtnForComm = true;                
            },
            //添加时段
            addTimes(item){
                this.timeChoiceBtn = true;
            },
            // 获取时段列表
            getTimesList: function () {
                this.$http.get('/product-supply-time?storeId='+this.curStoreId).then((res)=>{
                    let body = res.data;
                    if ( body && body[0] ) {
                        this.timeList = body;
                    }
                }).catch((err)=>{

                })
            },
            selOkForSpec(data){
                console.log(data);
                this.seledSpec = data.nowSelectGoods;
                this.showSpec = false;
            },
            selOkForPei(data){
                console.log(data);
                this.seledPeiGoods = data.nowSelectGoods;
                this.showPei = false;
            },
            selOk(data){
                console.log(data);
                this.seledMats = data.nowSelectGoods;
                this.showMat = false;
            },
            uploadGood(item) {
                //修改商品
                this.btnId = item.id;
                this.addGoodCheckArr = [];
                this.isAutoSearchBtn = false;
                if(item.specs && Array.isArray(item.specs)){
                    let norArr = [];
                    let tempSpec = [];
                    item.specs.forEach(it=>{
                        if(this.normalSpecs.indexOf(it)!=-1){
                            norArr.push(it);
                        }else{
                            tempSpec.push(it);
                        }
                    });
                    this.seledNorSpec = norArr;
                    this.specs = tempSpec
                }
                // 
                let specIds = [];
                if(item.productSpecs && Array.isArray(item.productSpecs) && item.productSpecs.length){
                    item.productSpecs.forEach(it=>{
                        specIds.push(it.id);  
                    })
                    this.seledSpec = item.productSpecs;
                }
                // 
                this.newGoods = {
                    productTypeId : item.typeId,
                    barCode       : item.barCode,
                    // costPrice     : item.costPrice,
                    salesPrice    : item.salesPrice,
                    inStockNumber : item.inStockNumber,
                    supplierName  : item.supplierName,
                    name          : item.name,
                    imageURL      : item.imageURL,
                    // productStatus : item.productStatus?'OFF':'ON',
                    // stockQuantityRatio : item.stockQuantityRatio,
                    commission : item.commission,
                    memberShow:item.memberShow,
                    disShow:item.disShow,
                    productQty:item.productQty,
                    labelEnabled:item.labelEnabled?1:0,
                    ipId:item.ipId==0?"":item.ipId,
                    threshold:item.threshold,//库存告警值
                    // 
                    sort:item.sort,
                    salesCount:item.salesCount,
                    salesShowEnabled:item.salesShowEnabled,
                    salesEnabled:item.salesEnabled,
                    timeRangeComm:item.openTimeEnabled,
                    note:item.note,
                    week:item.week ? item.week.split(",") : [],
                    // 
                    postEnabled:item.postEnabled,
                    // 
                    specIds,
                };
                console.log(this.newGoods)
                if(this.newGoods.week && this.newGoods.week.length && this.newGoods.week.length == 7){
                    this.isAllWeek = true;
                }else{
                    this.isAllWeek = false;
                }
                if(item.productMaterialItems && Array.isArray(item.productMaterialItems) && item.productMaterialItems.length){
                    item.productMaterialItems.forEach(it=>{
                        it.formId = it.id;
                        it.name = it.productMaterialName;
                        it.count = it.qty;
                    })
                }
                this.seledMats = item.productMaterialItems;
                let newTimeListForComm = []
                for(let i=0;i<item.list.length;i++){
                    let obj = {
                        commission:item.list[i].commission,
                        timeRange:[new Date(`2020/01/01 ${item.list[i].begin}`),new Date(`2020/01/01 ${item.list[i].end}`)],
                    }
                    if(item.list[i].begin == "aN:aN:00" || item.list[i].end == "aN:aN:59"){
                        obj = {
                            commission:item.list[i].commission,
                            timeRange:["",""]
                        }
                    }
                    
                    newTimeListForComm.push(obj);
                }
                this.newTimeListForComm =newTimeListForComm;
                //岗位提成信息 
                let newJobListForComm = []
                for(let i=0;i<item.postCommissions.length;i++){
                    let obj = {
                        commission:item.postCommissions[i].commission,
                        groupId:item.postCommissions[i].groupId,
                        id:item.postCommissions[i].id,
                    }
                    
                    newJobListForComm.push(obj);
                }
                this.newJobListForComm =newJobListForComm;
                // 
                if(item.supplyTimes){
                    this.newTimeList = [];
                    let supplyTimes = JSON.parse(item.supplyTimes);
                    for(var i=0;i<supplyTimes.length;i++){
                        if(supplyTimes[i].id) {
                            this.newTimeList.push(supplyTimes[i])
                        }
                    }
                }else{
                    this.newTimeList = [];
                }
                this.timeChoiceBtn = false;
                this.isStock = item.stockEnabled?'ON':'OFF';
                this.kitchenPrintEnabled = item.kitchenPrintEnabled?'ON':'OFF';
                this.isDirectThermal = item.isDirectThermal?'ON':'OFF';
                this.getPeiWithGoods(item);
                // this.dialogVisible = true ;
                // 
                this.vipEnable = item.memberShow;//是否开启会员价格
                this.vipPrice = item.memberPrice//会员价格
                this.discountEnable = item.disShow//是否开启折扣
                this.discountPrice = (item.disPrice)*100;//折扣百分比
                let dateForBeg = new Date("2018-11-11 "+item.nowHours);
                let dateForEnd = new Date("2018-11-11 "+item.tomorrowHour);
                this.beginTime = dateForBeg;//折扣起始时间
                this.endTime = dateForEnd;//折扣终止时间
                this.disCom = item.disCom;
                // this.croseDay = item.cross;//折扣时间是否跨天s

                // 是否显示在客户端和是否是否允许购买
                this.pcEnable = item.showEnabled;
                this.pcBuyEnable = item.purchaseEnabled;
            },
            getPeiWithGoods(item){
                this.$http({
                    url:"match/product/list",
                    method:"POST",
                    data:{
                        productId:item.id
                    }
                }).then(res=>{
                    if(res.data && Array.isArray(res.data) && res.data.length){
                        res.data.forEach(it=>{
                            it.count = 1;
                        })
                    }
                    this.seledPeiGoods = res.data ? res.data : [];
                    this.dialogVisible = true ;
                })
            },
            //初始化 商品数据
            initDate(){
                this.timeChoiceBtn = false;
                this.isAutoSearchBtn = true;
                this.btnId = null;
                this.addId = null;
                this.tbForm = {
                    storeIds:[]
                };
                this.newGoods = {
                    id: '', // 员工id
                    productTypeId: '', // 商品id
                    name: '', // 员工姓名
                    barCode: '', // 条码
                    // costPrice: '', // 进价
                    salesPrice: '', // 出售价
                    storeId: this.curStoreId, // 商铺id
                    inStockNumber: '' ,// 库存
                    supplierName: '', // 供应商
                    productStatus: 'ON', // 状态
                    imageURL: '', // 图片路径
                    // stockQuantityRatio : '',
                    commission:'0',//商品提成
                    productQty:1,//默认商品数量
                    labelEnabled:0,
                    ipId:"",
                    threshold:0,
                    // 
                    sort:0,
                    salesCount:0,
                    salesShowEnabled:false,
                    salesEnabled:false,
                    timeRangeComm:false,
                    note:"",
                    week:[],
                    postEnabled:false,
                    // openMatchEnabled:false,
                    specIds:[],
                }

                this.newTimeList = [];
                this.newTimeListForComm = [{
                    commission:"",
                    timeRange:[]
                }];
                // 
                this.newJobListForComm = [
                    {
                        commission:"",
                        groupId:"",
                        id:""
                    }
                ];
                // 
                this.isStock = 'OFF';
                // 
                this.discountEnable = false;
                this.vipEnable = false;
                this.discountPrice = 100,
                this.vipPrice = "";
                this.beginTime = "";
                this.endTime = "";
                this.disCom = 0;
                this.seledMats = [];
                this.seledSpec = [];
                this.seledPeiGoods = [];
                // 
            },
            addGoods(){
                //点击添加商品，清空 newGoods并获取获取商品分类
                this.dialogVisible = true;
                this.initDate();
            },
            // 筛选商品
            fliterGoods () {
                let fliter_stock = '-1';
                let fliter_kitchen = '-1';
                if ( this.fliter_stock == 'true' ) {
                    fliter_stock = 1;
                } else if ( this.fliter_stock == 'false' ) {
                    fliter_stock = 0;
                }
                if ( this.fliter_kitchen == 'true' ) {
                    fliter_kitchen = 1;
                } else if ( this.fliter_kitchen == 'false' ) {
                    fliter_kitchen = 0;
                }

                this.$http.get('/products?storeId='+this.curStoreId+'&typeId='+this.fliter_type+'&isStock='+fliter_stock+'&kitchen='+fliter_kitchen).then((res)=>{
                    this.vipData = res.data;
                    this.goodsNum.total = res.data.length;
                    if( this.vipData.length < 6 ){
                        for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                            this.vipData.push({})
                        }
                    }
                })
            },
            // 删除商品
            delGoods(goodId){
                this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除商品
                   this.$http.delete('/products?id='+goodId).then((res)=>{
                        if( res.status ){
                            if(this.fliter_type!=''||this.fliter_stock!=''||this.fliter_kitchen!=''){
                                this.fliterGoods();
                            }else{
                                this.getGoodsData();
                            }
                        }
                    })
                }).catch(() => {});
            },
            getGoodsData(){
                // this.$http.get('/products?storeId='+this.curStoreId).then((res)=>{
                this.$http.get('/get-ps?storeId='+this.curStoreId).then((res)=>{
                    this.vipData = res.data;
                    this.goodsNum.total = res.data.length;
                    if( this.vipData.length < 6 ){
                        for(let i = 0, len = 6 - this.vipData.length; i < len; i++){
                            this.vipData.push({})
                        }
                    }
                })
            },
            checkFn(){
                //正则验证方法
                if(!this.newGoods.name){
                    this.$message({
                        message: '请输入商品名',
                        customClass: 'error'
                    })
                    return true;
                }
                if(this.newGoods.note!=null){
                    if(this.newGoods.note.length>15){
                        this.$message({
                            message: '商品描述最长15个字符',
                            customClass: 'error'
                        })
                        return true;
                    }
                }
                
                // 分类限制，如果选择了网费分类，商品名则必须含有网费字眼，其他商品转为网费分类同样需要网费字眼
                if(this.newGoods.productTypeId == 1){
                    if(!/(\u7f51\u8d39)/.test(this.newGoods.name)){
                        this.$message({
                            message: '当前选择了火星网费分类，商品名必须含有网费字眼。',
                            customClass: 'error'
                        })
                        return true;
                    }
                }else{
                   if(/(\u7f51\u8d39)/.test(this.newGoods.name)){
                        this.$message({
                            message: '当前分类下，商品名不能含有网费字眼。',
                            customClass: 'error'
                        })
                        return true;
                    } 
                }
                // 
                if(this.isStock=="ON"){
                    if(!/(^0{1}$)|(^[1-9][0-9]*$)/.test(this.newGoods.threshold)){
                        this.$message({
                            message: '数量输入有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                }else if(this.isStock=="OFF"){
                    // if(!/^\d+(\.{0,1}\d+){0,1}$/.test(this.newGoods.stockQuantityRatio)){
                    //     this.$message({
                    //         message: '商品规格格式有误',
                    //         customClass: 'error'
                    //     })
                    //     return true;
                    // }
                }
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.salesPrice)){
                    this.$message({
                        message: '销售价格格式有误',
                        customClass: 'error'
                    })
                    return true;
                }
                if(!/^[1-9][0-9]*$/.test(this.newGoods.productQty)){
                    this.$message({
                        message: '数量输入有误',
                        customClass: 'error'
                    })
                    return true;
                }
                if(this.vipEnable){
                    if(!this.vipPrice){
                      this.$message({
                            message: '请输入会员价',
                            customClass: 'error'
                        })
                        return true;  
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.vipPrice)){
                        this.$message({
                            message: '会员价格格式有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                }
                if(this.discountEnable){
                    if(!this.discountPrice){
                      this.$message({
                            message: '请输入折扣百分比',
                            customClass: 'error'
                        })
                        return true;  
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.discountPrice)){
                        this.$message({
                            message: '折扣格式有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.disCom)){
                        this.$message({
                            message: '提成价格格式有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(!this.beginTime||!this.endTime){
                        this.$message({
                            message: '折扣时间有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(this.beginTime=="aN:aN:aN"||this.endTime=="aN:aN:aN"){
                       this.$message({
                            message: '折扣时间有误',
                            customClass: 'error'
                        })
                        return true; 
                    }
                }
                
                if(!this.newGoods.productTypeId){
                    this.$message({
                        message: '请选择分类',
                        customClass: 'error'
                    })
                    return true;
                }
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.commission)){
                    this.$message({
                        message: '商品提成格式有误',
                        customClass: 'error'
                    })
                    return true;
                }
                if(this.newGoods.salesShowEnabled){
                    if(!/^\d*$/.test(this.newGoods.salesCount)){
                        this.$message({
                            message: '基础数量输入有误',
                            customClass: 'error'
                        })
                        return true;
                    }
                    if(!/^\d*$/.test(this.newGoods.sort)){
                        this.$message({
                            message: '排序输入错误',
                            customClass: 'error'
                        })
                        return true;
                    }
                }
            },
            beforeUpGoods(){
                if(!this.btnId && (Array.isArray(this.storeList) && this.storeList.length>1)){
                    this.$confirm('是否将此商品同步到其它店铺 （其它店铺需要建立相同分类名）？', '提示', {
                        confirmButtonText: '否，不用同步',
                        cancelButtonText: '是，同步到其他店',
                        type: 'warning',
                        showClose:false,
                        distinguishCancelAndClose:true,
                        closeOnPressEscape:false,
                        closeOnClickModal:false,
                    }).then(() => {
                        this.tbForm = {
                            storeIds:[]
                        }
                        this.upGoods();
                    }).catch(err=>{
                        this.shareGoods = true;
                    })
                }else{
                    this.tbForm = {
                        storeIds:[]
                    }
                    this.upGoods();
                }
            },
            doUpGoods(){
                if(!this.tbForm.storeIds || !Array.isArray(this.tbForm.storeIds) || !this.tbForm.storeIds.length){
                    this.$confirm('未选择同步店铺，是否仅将商品添加到此店铺', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        showClose:false,
                        distinguishCancelAndClose:true,
                        closeOnPressEscape:false,
                        closeOnClickModal:false,
                    }).then(() => {
                        this.shareGoods = false;
                        this.upGoods();
                    }).catch(err=>{
                         
                    })
                }else{
                    this.shareGoods = false;
                    this.upGoods();
                }
            },
            cancelTb(){
                this.shareGoods = false;
                this.tbForm = {
                    storeIds:[]
                }
                // this.$confirm('确认取消将商品同步到其他店铺?', '提示', {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         this.shareGoods = false;
                //         this.tbForm = {
                //             storeIds:[]
                //         }
                //     })
            },
            upGoods(){
                // console.log(this.newTimeListForComm);
                // console.log(new Date((this.newTimeListForComm[0].timeRange[0])).Format("hh:mm:00"))
                // return;
                if(this.checkFn()) {
                    //正则验证
                    return;
                }
                // 
                // 
                if ( !this.addGoodApiBtn ) {
                    return;
                }
                this.addGoodApiBtn = false;
                let commTimeArr = [];
                let postParams = [];
                if(this.newGoods.timeRangeComm && !this.newGoods.postEnabled){
                    for(let i=0;i<this.newTimeListForComm.length;i++){
                         if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newTimeListForComm[i].commission)){
                            this.$message({
                                message: '商品提成格式有误',
                                customClass: 'error'
                            })
                            this.addGoodApiBtn = true;
                            return true;
                        }
                        if(!this.newTimeListForComm[i].timeRange||!this.newTimeListForComm[i].timeRange[0]||!this.newTimeListForComm[i].timeRange[1]||this.newTimeListForComm[i].timeRange.length==0){
                            this.$message({
                                message: '请选择时间',
                                customClass: 'error'
                            })
                            this.addGoodApiBtn = true;
                            return true;
                        }
                        let obj = {
                            commission:Number(this.newTimeListForComm[i].commission),
                            begin:new Date(this.newTimeListForComm[i].timeRange[0]).Format("hh:mm:00"),
                            end:new Date(this.newTimeListForComm[i].timeRange[1]).Format("hh:mm:59")
                        }
                        commTimeArr.push(obj);
                    }
                }
                // 
                if(this.newGoods.postEnabled){
                    let had = {};
                    let hadFlag = false;
                    for(let i=0;i<this.newJobListForComm.length;i++){
                        if(!had[this.newJobListForComm[i].groupId]){
                            had[this.newJobListForComm[i].groupId] = true;
                        }else{
                            hadFlag = true;
                        }
                    }
                    if(hadFlag){
                        this.$message({
                            message: '岗位设置不可重复',
                            customClass: 'error'
                        })
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    for(let i=0;i<this.newJobListForComm.length;i++){
                         if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newJobListForComm[i].commission)){
                            this.$message({
                                message: '商品提成格式有误',
                                customClass: 'error'
                            })
                            this.addGoodApiBtn = true;
                            return true;
                        }
                        if(!this.newJobListForComm[i].groupId){
                            this.$message({
                                message: '请选择岗位',
                                customClass: 'error'
                            })
                            this.addGoodApiBtn = true;
                            return true;
                        }
                        let obj = {
                            commission:Number(this.newJobListForComm[i].commission),
                            groupId:this.newJobListForComm[i].groupId,
                            id:this.newJobListForComm[i].id ? this.newJobListForComm[i].id : undefined,
                        }
                        postParams.push(obj);
                    }
                }
                console.log(this.newJobListForComm);
                // 

                let flag = false;
                let newTimeListForComm = commTimeArr;
                if(newTimeListForComm.length>1){
                    for(let i=1;i<newTimeListForComm.length;i++){
                        
                        let tempArrMax = [new Date(`2020/01/01 ${newTimeListForComm[0].begin}`).getTime(),new Date(`2020/01/01 ${newTimeListForComm[i].begin}`).getTime()];
                        let tempArrMin = [new Date(`2020/01/01 ${newTimeListForComm[0].end}`).getTime(),new Date(`2020/01/01 ${newTimeListForComm[i].end}`).getTime()];


                        // let tempArrMax = [item.startTimeForFee,newTimeListForComm[i].startTimeForFee];
                        // let tempArrMin = [item.endTimeForFee,newTimeListForComm[i].endTimeForFee];
                        if(Math.max.apply(null, tempArrMax)<= Math.min.apply(null, tempArrMin)){
                            flag = true;
                        }
                    }
                }
                if(flag){
                    this.$message({
                        message: "时间不允许重叠，请重新选择",
                        customClass: 'error'
                    });
                    this.addGoodApiBtn = true;
                    return;
                }


                let arr1 = this.newTimeList;
                let arr2 = this.timeList;
                let supplyTimes = [];
                if(arr1.length){
                    for(var i=0;i<arr1.length;i++){
                        for(var j=0;j<arr2.length;j++){
                            if(arr1[i].id==arr2[j].id){
                                supplyTimes.push(arr2[j])
                            }
                        }
                    }
                }
                let ipName="";
                let port=0;
                let ipAddress = "";

                if(this.newGoods.ipId!=0 && this.newGoods.ipId){
                    for(let i=0;i<this.printEr.length;i++){
                        if(this.printEr[i].id==this.newGoods.ipId){
                            ipName = this.printEr[i].name;
                            port = this.printEr[i].port;
                            ipAddress = this.printEr[i].ipAddress;
                        }
                    }
                }
                let gname = String(this.newGoods.name.replace(/\s*/g,""));
                // 
                if(this.newGoods.timeRangeComm && !this.newGoods.postEnabled){
                    if(!commTimeArr || !commTimeArr.length){
                        this.$message({
                            message: "请添加时间段",
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return;
                    }
                }
                if(this.newGoods.postEnabled && (!postParams || !postParams.length)){
                    this.$message({
                        message: "请添加岗位提成信息",
                        customClass: 'error'
                    });
                    this.addGoodApiBtn = true;
                    return;
                }
                // 
                let specIds = [];
                if(this.seledSpec && Array.isArray(this.seledSpec) && this.seledSpec.length){
                    this.seledSpec.forEach(it=>{
                        specIds.push(it.id);
                    })
                }
                let goods = {
                    "id"            :  this.btnId ? this.btnId : this.$uuid.create(1).hex,
                    "storeId"       :  this.curStoreId,
                    "name"          :  gname,
                    "barCode"       :  this.newGoods.barCode,
                    // "costPrice"     :  parseFloat(this.newGoods.costPrice),

                    "salesPrice"    :  parseFloat(this.newGoods.salesPrice),
                    "inStockNumber" :  parseFloat(this.newGoods.inStockNumber),
                    "productTypeId" : this.newGoods.productTypeId,
                    "productQty" : this.newGoods.productQty,
                    "imageURL"      : this.newGoods.imageURL?this.newGoods.imageURL:'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png',
                    "supplierName"  : this.newGoods.supplierName,
                    "supplyTimes":  JSON.stringify(supplyTimes),
                    "productStatus" : this.newGoods.productStatus,
                    "commission"    : parseFloat(this.newGoods.commission),
                    "stockEnabled" : this.isStock==='OFF'? false : true,
                    "kitchenPrintEnabled" : this.kitchenPrintEnabled==='OFF'? false : true,
                    "isDirectThermal" : this.isDirectThermal==='OFF'? false : true,
                    labelEnabled:this.newGoods.labelEnabled,
                    "ipId":this.kitchenPrintEnabled==='OFF'?"":this.newGoods.ipId,
                    ipName:this.kitchenPrintEnabled==='OFF'?"":ipName,
                    port:this.kitchenPrintEnabled==='OFF'?"":port,
                    ipAddress:this.kitchenPrintEnabled==='OFF'?"":ipAddress,
                    "threshold" : this.isStock=="ON"?this.newGoods.threshold:0,
                    // "stockQuantityRatio" : parseFloat(this.newGoods.stockQuantityRatio),
                    // 
                    // 
                    sort:this.newGoods.sort,
                    salesCount:this.newGoods.salesCount,
                    salesShowEnabled:this.newGoods.salesShowEnabled,
                    salesEnabled:this.newGoods.salesEnabled,
                    // 
                    items:commTimeArr,
                    openTimeEnabled:this.newGoods.timeRangeComm,
                    // 
                    note:this.newGoods.note,
                    week:Array.isArray(this.newGoods.week) ? this.newGoods.week.join() : this.newGoods.week,
                    // 
                    postParams,
                    postEnabled:this.newGoods.postEnabled,
                    specIds,
                    // specs:[...this.seledNorSpec,...this.specs]
                };
                if(!this.btnId && this.tbForm.storeIds && Array.isArray(this.tbForm.storeIds) && this.tbForm.storeIds.length){
                    goods = {...goods,storeIds:this.tbForm.storeIds}
                }
                this.$http.put('/products',goods).then(async (res)=>{
                    this.addGoodApiBtn = true;
                    this.isAutoSearchBtn = true;
                    if ( !this.btnId ) {

                            let dateBeg = new Date(this.beginTime);
                            let dateEnd = new Date(this.endTime);
                            let resFlag = await this.disOrVip(goods.id,this.vipPrice,this.discountPrice,this.disCom,dateBeg.Format("hh:mm:ss"),dateEnd.Format("hh:mm:ss"),this.tbForm.storeIds);
                            // 是否显示在客户端和是否在客户端允许购买
                            await this.setForPc(goods.id,this.pcEnable,this.pcBuyEnable,this.tbForm.storeIds);
                        // }
                        // this.dialogVisible = false;
                        if(resFlag){
                            this.$message({
                                message: '添加商品成功',
                                customClass: 'success'
                            });
                            setTimeout( ()=> { 
                                this.initDate();
                            },500);
                        }
                        
                    } else {
                        
                            let dateBeg = new Date(this.beginTime);
                            let dateEnd = new Date(this.endTime);
                            // 是否显示在客户端和是否在客户端允许购买
                            await this.setForPc(this.btnId,this.pcEnable,this.pcBuyEnable);
                            let resFlag = await this.disOrVip(this.btnId,this.vipPrice,this.discountPrice,this.disCom,dateBeg.Format("hh:mm:ss"),dateEnd.Format("hh:mm:ss"))
                            if(resFlag){
                                this.$message({
                                    message: '修改商品成功',
                                    customClass: 'success'
                                });
                            }
                            
                    }
                    
                    // 
                    let params = [];
                    if(this.seledMats && Array.isArray(this.seledMats) && this.seledMats.length){
                        this.seledMats.forEach(it=>{
                            let obj = {
                                id:it.formId?it.formId:0,
                                qty:it.count,
                                productMaterialId:it.productMaterialId,
                                productMaterialName:it.name,
                            }
                            params.push(obj);
                        })
                    }
                    await this.upOriGoods(res.data.id,params);
                    // 
                    let paramsForPei = [];
                    if(this.seledPeiGoods && Array.isArray(this.seledPeiGoods) && this.seledPeiGoods.length){
                        this.seledPeiGoods.forEach(it=>{
                            // let obj = {
                            //     id:it.formId?it.formId:0,
                            //     qty:it.count,
                            //     productId:it.productMaterialId,
                            //     productMaterialName:it.name,
                            // }
                            paramsForPei.push(it.id);
                        })
                    }
                    console.log(paramsForPei)
                    await this.upPeiGoods(res.data.id,paramsForPei);
                    setTimeout(()=>{
                        // this.getGoodsData();
                        if(this.fliter_type!=''||this.fliter_stock!=''||this.fliter_kitchen!=''){
                            this.fliterGoods();
                        }else{
                            this.getGoodsData();
                        }
                        if ( this.btnId ) {
                            this.dialogVisible = false;
                        }
                    },250);
                    // 
                }).catch(()=>{
                    // this.tbForm = {
                    //     storeIds:[]
                    // }
                    this.addGoodApiBtn = true;
                })
            },
            upPeiGoods(productId,productIds){
                return new Promise((resolve,reject)=>{
                    this.$http({
                        url:"match/product/add",
                        method:"POST",
                        data:{
                            productId,
                            productIds
                        }
                    }).then(res=>{
                        resolve(res);
                    }).catch(err=>{
                        reject(err);
                    });
                })
                
            },
            upOriGoods(productId,params){
                return new Promise((resolve,reject)=>{
                    this.$http({
                        url:"edit/material",
                        method:"POST",
                        data:{
                            productId,
                            params
                        }
                    }).then(res=>{
                        resolve();
                    }).catch(err=>{
                        reject();
                    });
                })
                
            },
            // 设置客户端是否允许购买和显示
            setForPc(productId,showEnabled,purchaseEnabled,storeIds=undefined){
                return new Promise((resolve,reject)=>{
                    this.$http({
                        url:"show-enabled",
                        method:"POST",
                        data:{
                        productId,
                        showEnabled:showEnabled?1:0,
                        purchaseEnabled:purchaseEnabled?1:0,
                        storeIds:storeIds?storeIds:undefined
                        }
                    }).then(res=>{
                        resolve(res);
                    }).catch(err=>{
                        reject(err);
                    })
                })
                
            },
            disOrVip(productId,memberPrice,disPrice,disCom,beginTime,endTime,storeIds=undefined){
                return new Promise((resolve,reject)=>{
                    if(beginTime!="aN:aN:aN" && endTime!="aN:aN:aN" && this.discountEnable){
                        if(new Date(`2020/01/01 ${endTime}`).getTime() <= new Date(`2020/01/01 ${beginTime}`).getTime()){
                            this.$message({
                            message: '折扣结束时间不能小于开始时间',
                            customClass: 'error'
                            })
                            reject(false);
                        }
                    }
                    let data={
                        productId,
                        beginTime:beginTime=="aN:aN:aN"?"":beginTime,
                        endTime:endTime=="aN:aN:aN"?"":endTime,
                        disShow:this.discountEnable?1:0,
                        disPrice:(disPrice/100).toFixed(2),
                        memberShow:this.vipEnable?1:0,
                        memberPrice,
                        disCom,
                        storeIds:storeIds?storeIds:undefined
                    } 
                    this.$http({
                        url:"update-slot",
                        method:"POST",
                        data
                    }).then(res=>{
                        console.log(res);
                    })
                    resolve(true);
                })
                
            },
            coverImg: function ( e ) {
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过20MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过20MB',
                        customClass: 'error'
                    })
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let that2 = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = that2.result; //获得图片的base64的数据


                            // 判断是否是移动端设备
                            let sUserAgent = navigator.userAgent.toLowerCase();
                            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
                            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                            let bIsAndroid = sUserAgent.match(/android/i) == "android";
                            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                                that.mobileUploadImg(imgBase64);
                            } else {
                                that.oldImgBase64 = imgBase64;
                                that.showCrop = true;
                            }
                        };
                        $('.pcImgFile').val('');
                        $('.mobileImgFile').val('');
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },
            // 移动端上传图片
            mobileUploadImg: function (imgBase64) {
                this.infoload = true;
                this.$http.post(API_BASE_URL+'v1/image/json/upload?storeId='+this.curStoreId, {file: imgBase64}).then((res)=>{
                    this.newGoods.imageURL = res.data.path;
                    this.infoload = false;
                }).catch(()=>{
                    this.infoload = false;
                });
            },
            // 获得裁剪后图片base64
            getCropImgBase: function ( imgUrl )　{
                this.newGoods.imageURL = imgUrl;
            },
            getSpecs(){
                this.$http({
                    url:"spec/list",
                    method:"POST",
                    data:{
                        storeId:this.curStoreId,
                    }
                }).then((res)=>{
                    console.log(res)
                    this.specList = res.data;
                })
            },
        },
        activated: function () {
            this.$http.get('/stores').then((res)=>{
                this.storeList = res.data;
            }).catch((err) => {
                
            })
            for (let i = 0; i < 6; i++) {
                this.vipData.push({});
            }

            //获取商品分类
            /*this.$http.get('/product-types-all?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
                this.typeList = this.typeList.concat(res.data);
               
                this.typeOptions.push({label: '全部',value: ''});
                for (var i = 0; i < res.data.length; i++) {
                    let obj={
                        value:res.data[i].id,
                        label:res.data[i].name
                    }
                    if(res.data[i].productTypeVos.length){
                        let son = res.data[i].productTypeVos;
                        let arr = [
                            {value:res.data[i].id,label:res.data[i].name}
                        ];
                        for (var j = 0; j < son.length; j++) {
                             let sonobj={
                                value:son[j].id,
                                label:"- "+son[j].name
                            }
                            arr.push(sonobj)
                        }
                        obj.children = arr;
                    }
                    this.typeOptions.push(obj);
                }
            })*/
            this.$http.get('/product-types?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
                this.typeList = res.data.data;
                this.systemData = res.data.systemData;
            })
            if(this.fliter_type!=''||this.fliter_stock!=''||this.fliter_kitchen!=''){
                this.fliterGoods();
            }else{
                this.getGoodsData();
            }
            // 
            this.getSpecs();
            // 
            this.getTimesList();
            this.getPrintIpInfo();
            this.getJobType();
        },
        mounted() {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
                $('.el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import '../../tableTemplate/tableTem.scss';
	@import "info.scss";
    .mat-goods{
        width: 100%;
    }
    .seled-mat-list{
        margin-top: 10px;
    }
    .el-tag{
        margin: 0 5px;
        background-color: #3068ff;
    }
    .itemSelect{
        
        .el-select__tags{
            display: flex;
            align-items: center;
            overflow: hidden;
            span{
                display: flex;
                align-items: center;
                display: none;
                &:first-child{
                    display: inherit;
                }
            }
            .el-tag{
                background-color: rgba(32,160,255,.1);
                .el-select__tags-text{
                    padding: 0 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .el-tag__close{
                    display: none;
                }
            }
            &::after{
                content:"...";
                display: none;
            }
        }
        &.showMore{
            .el-select__tags{
                    &::after{
                    content:"...";
                    display: inline-block;
                }
            }
        }
    }
    .el-select__tags-text{
        color: #fff;
    }
    .el-message-box__btns{
        .el-button--default{
        }
    }
</style>



// WEBPACK FOOTER //
// info.vue?c8133d6a